angular
  .module('biz-ng-career-details')
  .constant('RelatedCareersDTD', {
    area_onet_data: {
      type: 'object',
      writeToKey: 'careersData'
    },
    onet: {
      type: 'object',
      writeToKey: 'allCareers'
    },
    skill: {
      type: 'object',
      writeToKey: 'allSkills'
    }
  })
  .factory('RelatedCareersBuilder', function RelatedCareersBuilder(Interface, RelatedCareersDTD, CareerBuilder) {
    function RelatedCareersDTO(data) {
      Interface.implement(RelatedCareersDTD, data, this);
      this.careersData = mapCareers.call(this, this.careersData);
    }

    var mapCareers = function mapCareers(group) {
      return _.isEmpty(group)
        ? []
        : _.map(
            group,
            function(career) {
              var onetCareer = this.allCareers[career.onet];
              onetCareer = _.omit(onetCareer, 'id'); //delete id to prevent change in career id

              career = _.merge(career, onetCareer);
              career = new CareerBuilder(career);

              //Map Skills
              career.topSkills = _.map(
                career.skills,
                function(skillId) {
                  return this.allSkills[skillId];
                },
                this
              );

              return career;
            },
            this
          );
    };

    return RelatedCareersDTO;
  });



// WEBPACK FOOTER //
// related_careers_builder.js